import { Select, SelectOption } from "@clockwise/design-system";
import { fg_muted } from "@clockwise/design-system/tokens";
import { Room } from "@clockwise/schema";
import { MeetingRoomRounded, DeleteRounded as RemoveIcon } from "@material-ui/icons";
import React from "react";

const RoomIcon = () => <MeetingRoomRounded htmlColor={fg_muted} />;

type Actions = "Remove";

type Props = {
  disabled: boolean;
  onRemove: () => void;
  selected?: Room;
};

export const SelectRoomActions = ({ disabled, onRemove, selected }: Props) => {
  const value = "" as const; // DEV NOTE: always keep select in "unselected" state

  const handleAction = (option: Actions) => {
    switch (option) {
      case "Remove":
        onRemove();
        break;
      default:
        break;
    }
  };

  if (!selected) {
    return null;
  }

  return (
    <Select disabled={disabled} onChange={handleAction} size="small" value={value} variant="inline">
      <SelectOption value="" icon={RoomIcon}>
        {selected.name}
      </SelectOption>
      <SelectOption
        value={"Remove" as Actions}
        icon={RemoveIcon}
        iconProps={{ className: "cw-text-destructive" }}
      >
        Remove
      </SelectOption>
    </Select>
  );
};
